import { Flex, Spinner } from '@chakra-ui/react';
import { FunctionComponent, lazy, Suspense } from 'react';
import { DiffCodeEditorProps } from './types';

export type { DiffCodeEditorProps } from './types';

// Monaco is several MB; loading it lazily keeps it out of the main bundle so other
// pages don't pay for it. Swap the editor implementation here without touching callers.
const MonacoDiffEditor = lazy(() => import('./MonacoDiffEditor'));

export const DiffCodeEditor: FunctionComponent<DiffCodeEditorProps> = (props) => (
  <Suspense
    fallback={
      <Flex h="100%" align="center" justify="center">
        <Spinner color="marketcast.primaryCta.1" thickness="3px" />
      </Flex>
    }
  >
    <MonacoDiffEditor {...props} />
  </Suspense>
);
